import React from 'react';
import styled from 'styled-components';
import { device } from 'js/config/style';

const FlowStepNumber = styled.div`
  background: #0016FF;
  color: white;
  font-weight: bold;
  border-radius: 50%;
  min-width: 50px;
  min-height: 50px;
  max-height: 50px;
  max-width: 50px;
  font-size: 18px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media(min-width: ${device.laptop }) {
    min-width: 50px;
    min-height: 50px;
    max-height: 50px;
    max-width: 50px;
  }
`;

function DAIStepNumber({
  step,
}) {
  return (
    <FlowStepNumber>
      {step}
    </FlowStepNumber>
  )
}

export default DAIStepNumber;